import React, { ReactElement } from "react";
import { RxCross2 } from "react-icons/rx";
import { Modal } from "react-responsive-modal";
import oc from "open-color";
import "react-responsive-modal/styles.css";
import c from "./CustomModal.module.css";

export default function CustomModal({
  children,
  title,
  isOpen,
  closeModal,
  width,
}: {
  children: ReactElement;
  title: string;
  isOpen: boolean;
  closeModal: () => void;
  width?: string;
}): ReactElement {
  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      center
      closeIcon={<RxCross2 color={oc.gray[5]} fontSize="20px" />}
      classNames={{
        modal: c.customModal,
        closeButton: c.customCloseButton,
      }}
      styles={{
        modal: {
          maxWidth: width || "500px",
        },
      }}
    >
      <div>
        <h5
          style={{
            borderBottom: "3px solid #000",
            marginBottom: "15px",
            color: oc.gray[7],
            paddingBottom: "7px",
          }}
        >
          {title}
        </h5>
        {children}
      </div>
    </Modal>
  );
}
